/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { api, post, type ApiResult } from "./client";

/**
 * Staging demo panel data source. The backend registers these routes only outside prod, so the
 * capability probe failing means the whole surface stays hidden.
 */

export type DemoRecipient = { label: string; phone: string };

export type DemoCapability = {
  enabled: boolean;
  providerHealthieId: string;
  bookablePatientHealthieId: string;
  recipients: DemoRecipient[];
};

export type FreedSlotResult = {
  appointmentHealthieId: string;
  freedSlotStartsAt: string;
};

export function getDemoCapability(): Promise<ApiResult<DemoCapability>> {
  return api<DemoCapability>("/v1/admin/demo");
}

export function runFreedSlot(
  toPhone: string,
  secondToPhone?: string,
): Promise<ApiResult<FreedSlotResult>> {
  return api<FreedSlotResult>(
    "/v1/admin/demo/freed-slot",
    post(secondToPhone ? { toPhone, secondToPhone } : { toPhone }),
  );
}

export function sendReply(toPhone: string, body: string): Promise<ApiResult<{ accepted: boolean }>> {
  return api<{ accepted: boolean }>("/v1/admin/demo/reply", post({ toPhone, body }));
}

export function seedOffer(
  toPhone: string,
  options: { patientHealthieId?: string; rank?: number; score?: string } = {},
): Promise<ApiResult<{ outreachId: string }>> {
  return api<{ outreachId: string }>("/v1/admin/demo/seed-offer", post({ toPhone, ...options }));
}

export function resetDemo(toPhone: string): Promise<ApiResult<{ touched: number }>> {
  return api<{ touched: number }>("/v1/admin/demo/reset", post({ toPhone }));
}

export function advanceTimers(): Promise<ApiResult<{ aged: number }>> {
  return api<{ aged: number }>("/v1/admin/demo/advance-timers", post({}));
}

export function seedTransition(): Promise<ApiResult<{ touched: number }>> {
  return api<{ touched: number }>("/v1/admin/demo/seed-transition", post({}));
}
